import React, { Fragment } from 'react';
import { GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import PropTypes from 'prop-types';
import List from './List';
import Legend from './Legend';
import {
  validColor,
  invalidColor,
  noDataColor,
  icon,
} from '../../utils/styleConst';
import { studioIsKo } from '../../utils/utils';

const GoogleMapComponent = ({
  isMarkerShown, onToggleOpen, openInfoWindowMarkerId, studioData, zoomToMarkers,
}) => (
  <Fragment>

    <GoogleMap
      ref={zoomToMarkers && zoomToMarkers}
      defaultCenter={{ lat: 48.8534, lng: 2.3488 }}
      defaultZoom={6}
    >
      {isMarkerShown &&
        studioData.map((studio) => {
          let color;

          if (studioIsKo(studio)) {
            color = noDataColor;
          } else if (studio.sensor[0].value === '0') {
            color = invalidColor;
          } else {
            color = validColor;
          }


          return (
            <Marker
              key={studio['@id']}
              position={{ lat: Number(studio.xLatitude), lng: Number(studio.xLongitude) }}
              icon={icon(color)}
              onClick={onToggleOpen(studio['@id'])}
            >
              {openInfoWindowMarkerId === studio['@id'] &&
                <InfoWindow key={studio['@id']} onCloseClick={onToggleOpen(studio['@id'])}>
                  <List studio={studio} />
                </InfoWindow>
              }
            </Marker>
          );
        })
    }
    </GoogleMap>
    <Legend studioData={studioData} />
  </Fragment>
);
GoogleMapComponent.defaultProps = {
  openInfoWindowMarkerId: null,
  zoomToMarkers: undefined,
};

GoogleMapComponent.propTypes = {
  isMarkerShown: PropTypes.bool.isRequired,
  onToggleOpen: PropTypes.func.isRequired,
  zoomToMarkers: PropTypes.func,
  openInfoWindowMarkerId: PropTypes.string,
  studioData: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default GoogleMapComponent;




// WEBPACK FOOTER //
// src/components/googleMap/GoogleMapComponent.jsx